import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Api from './api';
import ActionTypes from './action-types';
import Actions from './actions';

const fetchMealTypes = action$ =>
    action$.ofType(ActionTypes.MEAL_TYPE_FETCH).mergeMap(({payload}) =>
        Api.fetchMealTypes(payload.institutionId, payload.childId)
            .map(mealTypes => Actions.fetchMealTypesSuccess(payload.institutionId, mealTypes))
            .catch(e => Observable.of(Actions.fetchMealTypesFailed(payload.institutionId, e.message))),
    );

const updateMealTypes = action$ =>
    action$.ofType(ActionTypes.MEAL_TYPE_UPDATE).mergeMap(({payload}) =>
        Api.updateMealTypes(payload.institutionId, payload.mealTypes)
            .flatMap(mealTypes => [
                Actions.updateMealTypesSuccess(payload.institutionId, mealTypes),
                GlobalEventActions.updateSuccess.action(i18next.t('settings.meal.mealTypes.success')),
            ])
            .catch(e => Observable.of(Actions.updateMealTypesFailed(payload.institutionId, e.message))),
    );

export default combineEpics(updateMealTypes, fetchMealTypes);
